import PersonIcon from '@mui/icons-material/Person';
import { Box, Button, Divider, Skeleton, Grid, useTheme, Typography, Link } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { HeaderContactDrawerOrder } from 'app/components/Candidate/CandidateProfile/CandidateHeader/HeaderContactDrawer';
import { CallPurpose, ChannelType, FormName, SendType, UseType } from 'app/components/Notification/Constants';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { MediaQuery } from 'app/layout/MediaQuery';
import { ResponsiveColumnContainer } from 'app/layout/ResposiveColumnContainer';
import { selectUser } from 'oidc/user.selectors';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { colors } from 'styles/styleVariables';
import { GetMomentOfDate } from 'utils/dates/moment';
import { Concatenate } from 'utils/string/string';
import {
  selectComparisonData,
  selectPlacementContactsData,
  selectPlacementCandidateRecords,
  selectPlacementHeaderData,
  selectMiscellaneousPlacementData,
  selectPlacementTags,
} from '../../../../../store/redux-store/placement-details/selectors';
import { notificationDataActions } from 'store/redux-store/notification/notification.redux';
import { notificationSelection } from 'store/redux-store/notification/notification.selector';
import { BestTimeToCall } from '../Edit/Components/BestTimeToCall';
// import { PlacementDate } from '../Edit/Components/PlacementDate';
import { AvailableStartDate } from '../Edit/Components/AvailableStartDate';
import { editAccessor, editableFields } from '../editUtils';
import { CandidateDrawerPreviewer } from 'app/components/GlobalSearch/Candidate/CandidateDrawerPreviewer';
import { DrawerFitted } from 'app/components/Common/Drawer/Drawer';
import { selectSubmissionInfo } from '../../../../../store/redux-store/placement-summary/selectors';
import { getSubstitutions } from '../helper';
import { SSN } from '../Edit/Components/SSN';
import { DateOfBirth } from '../Edit/Components/DateOfBirth';
import moment from 'moment';
import { EmailDefaultValues } from 'app/models/Email/IEmail';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import { userDevicePreferenceActions } from 'oidc/UserDevicePreference/userPreference.redux';
import { IRecentHistoryPlacement } from 'app/models/Global/RecentHistoryModels';
import _ from 'lodash';
import { OverflowTooltip } from 'app/components/Common/Tooltips';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { isNotInteger } from 'app/helpers/objectHelpers';
import HeaderButton from '@AMIEWEB/Common/Buttons/HeaderButton';
import { missingField } from 'app/constants';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import CommunicationStack from '@AMIEWEB/Notification/MultiChannel/CommunicationTooltip/CommunicationStack';
import { PlacementTagsWrapper } from './PlacementTagsWrapper/PlacementTagsWrapper';
import { selectCandidateProfileDrawer, selectOrderDrawer } from 'app/ApplicationRoot/Global.selectors';
import { OrderPreviewDrawerViewer } from '@AMIEWEB/GlobalSearch/Order/OrderPreviewDrawerViewer';
import { PlacementShift } from '../Edit/Components/PlacementShift';
import { PlacementChangeDialog } from '@AMIEWEB/Placement/PlacementChange/PlacementChangeDialog';
import { PreferenceCosmosKeys } from 'oidc/UserDevicePreference/utils';
import { TooltipVmsDetails, VmsReqNumber } from '../Edit/Components/VmsReqNumber';
import { ContractHours } from '../Edit/Components/ContractHours';
import { isDisplayContractHours } from './utils';
import { FacilityLocation } from './FacilityLocation';
import { PlacementLength } from '../Edit/Components/PlacementLength';
import { PlacementEndDate } from '../Edit/Components/PlacementEndDate';
import { PlacementStartDate } from '../Edit/Components/PlacementStartDate';
import MarginToolIcon from 'assets/images/MarginTool/Margin_Tool_Icon.svg';
import { useDecision } from '@optimizely/react-sdk';
import { ff_margin_tool_placement_profile } from 'app/constants/FeatureFlags/MarginTool/Keys';
import { ChangeOrderIDLink } from '@AMIEWEB/Placement/ChangeOrderID/ChangeOrderIDLink';
import { ff_placement_ui_change_order_on_placement } from 'app/constants/FeatureFlags/Placement/Keys';
import { Link as RouteLink } from 'react-router-dom';
import { getPlacementFlagTypes } from './helper';
import { TagOption } from './PlacementTagsWrapper/PersonalTags';
import { SkillSetContent } from '@AMIEWEB/Facility/FacilityDetails/FacilityHeader/HeaderUtils';
import { ISkillSetInfo } from '@AMIEWEB/Facility/FacilityStore/Facility.model';
import { getAMIECategorySearch } from 'app/services/SharedServices/SharedServices';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { orderFlattenData } from '@AMIEWEB/GlobalSearch/Order/SearchHelper';

const useStyles = makeStyles<{ width: number }>()((theme, props) => ({
  container: {
    flexWrap: 'nowrap',
  },
  leftLings: {
    maxWidth: '190px !important',
  },
  pidContainer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  alignCenterDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '4px 0px',
  },
  contactBtn: {
    backgroundColor: '#F8F8F8',
    justifyContent: 'start',
    border: '1px solid #006fb9',
    borderRadius: 4,
    fontSize: 12,
    marginTop: 4,
    width: 'auto',
    minWidth: props.width || 156,
    '&:hover': {
      backgroundColor: '#006FB9',
      color: '#fff',
      border: '1px solid #006fb9',
    },
  },
  circleContainer: {
    maxWidth: '42px !important',
  },
  marginRight: {
    marginRight: '17px !important',
  },
  marginToolBtn: {
    marginTop: 9,
    width: '42px',
    height: '42px',
    '&:hover': {
      backgroundColor: theme.palette.system.navyBlueWithOpacity,
      borderRadius: '100%',
    },
  },
  archiveBtn: {
    backgroundColor: '#75787B',
    justifyContent: 'center',
    borderRadius: '0 0 4px 4px',
    color: '#fff',
    border: '0px !important',
    pointerEvents: 'none',
    height: 24,
    fontSize: 10,
    width: 'auto',
    minWidth: props.width || 150,
    marginLeft: 1,
  },
  divSpace: {
    padding: '0 4px',
  },
  divider: {
    margin: '0 8px',
  },
  tailStrip: {
    background: 'rgba(102, 153, 204, 0.33)',
    borderRadius: 3,
    padding: 6,
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  rowHeadDefaultColor: {
    color: '#333333 !important',
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  rowContentDefaultColor: {
    color: '#555555 !important',
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  rowHead: {
    fontSize: 12,
    fontWeight: 400,
    whiteSpace: 'nowrap',
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  rowContent: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    paddingLeft: 12,
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  rowContentMargin: {
    // Resolve issue: Row content is misplaced (Undone 10/27/2021)
    // 10/27/2021 - removed top margin to items are centered vertically
    // marginTop: 3,
    marginTop: 0,
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  lowRatioLayout: {
    fontSize: '12px !important',
    whiteSpace: 'nowrap',
  },
  tailStripHead: {
    fontSize: 14,
    color: '#003E68',
    fontWeight: 500,
  },
  brandName: {
    color: '#E89120',
    fontSize: 14,
  },
  headerData: {
    fontSize: 14,
  },
  placementDateTitle: {
    whiteSpace: 'pre',
  },
  defaultText: {
    fontSize: 14,
    color: '#555555',
  },
  unitTag: {
    fontSize: 14,
    color: '#555555',
    // Above 1280px
    '@media (min-width: 1280px)': {
      maxWidth: 180,
    },
    // Between 1280px and 1060px
    '@media (max-width: 1280px)': {
      maxWidth: 130,
    },
    //Below 1060px
    '@media (max-width: 1060px)': {
      maxWidth: 80,
    },
  },
  address: {
    paddingTop: 2,
    // Above 1280px
    '@media (min-width: 1280px)': {
      maxWidth: 160,
    },
    // Between 1280px and 1060px
    '@media (max-width: 1280px)': {
      maxWidth: 120,
    },
    //Below 1060px
    '@media (max-width: 1060px)': {
      maxWidth: 80,
    },
  },
  facilityTag: {
    // Above 1280px
    '@media (min-width: 1280px)': {
      maxWidth: 350,
    },
    // Between 1280px and 1060px
    '@media (max-width: 1280px)': {
      maxWidth: 300,
    },
    //Below 1060px
    '@media (max-width: 1060px)': {
      maxWidth: 230,
    },
  },
  fontSize12: {
    fontSize: 12,
  },
  skeleton: {
    borderRadius: 4,
  },
  tableGridContainer: {
    marginTop: -18,
    flexWrap: 'nowrap',
    overflow: 'visible',
    '@media (max-width: 1440px)': {
      flexWrap: 'wrap',
    },
    '@media (max-width: 1024px)': {
      paddingLeft: 4,
      flexWrap: 'wrap',
    },
    '@media (max-width: 980px)': {
      paddingLeft: 12,
      flexWrap: 'wrap',
    },
  },
  tableGridMargin: {
    marginTop: -16,
  },
  tableGrid: {
    width: 'fit-content',
    flexShrink: 0,
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'visible',
  },
  tableGridColumn5: {
    width: 'fit-content',
    flexShrink: 0,
    flexGrow: 1,
    minWidth: 260,
    maxWidth: '100%',
    overflow: 'hidden',
    '@media (min-width: 1500px)': {
      maxWidth: 430,
      overflow: 'visible',
    },
    '@media (min-width: 1024px) and (max-width: 1499px)': {
      maxWidth: 320,
      overflow: 'visible',
    },
    '@media (max-width: 1024px)': {
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
    },
  },
  link: {
    color: colors.amnBlue,
    textDecoration: 'none',
    fontWeight: 450,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  tags: {
    flexBasis: '25%',
    flexGrow: 1,
    msOverflowStyle: 'none',
    minWidth: 0,
    maxWidth: '100%',
    '@media (max-width: 1023px)': {
      flexBasis: '100%',
    },
  },
  colorDot: {
    width: 16,
    height: 16,
    borderRadius: '50%',
    marginTop: 12,
    marginRight: 6,
  },
}));

export const copyToClipBoard = divIdentifier => {
  var range = document.createRange();
  const devElement = document.getElementById(divIdentifier);
  if (devElement) {
    range.selectNode(devElement);
    window?.getSelection()?.removeAllRanges(); // clear current selection
    window?.getSelection()?.addRange(range); // to select text
    // Added below line since ctrl v is not working
    navigator.clipboard.writeText(range.toString());
    // document.execCommand('copy');
    window?.getSelection()?.removeAllRanges(); // to deselect
    return true;
  } else return false;
};

const temporaryPhoneTypeId = 3;

const getPlacementPhoneTypeId = phone =>
  Number(phone?.phoneTypeId ?? phone?.phoneTypeID ?? phone?.PhoneTypeID);

const isTemporaryPhone = phone =>
  getPlacementPhoneTypeId(phone) === temporaryPhoneTypeId ||
  phone?.phoneTypeDescription?.toLowerCase?.() === 'temporary';

const getDisplayableCandidatePhoneNumbers = phoneNumbers =>
  (Array.isArray(phoneNumbers) ? phoneNumbers : phoneNumbers ? [phoneNumbers] : []).filter(
    phone => phone?.phoneNumber && !isTemporaryPhone(phone),
  );

interface IOpenProfileDrawer {
  placementSidePanel: boolean;
}

export const PlacementHeader = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const theme = useTheme();

  const notificationData = useSelector(notificationSelection);
  const orderDrawer = useSelector(selectOrderDrawer);
  const params = useParams<{ placementId: string }>();

  const { flattenedContacts: placementContacts } = useSelector(selectPlacementContactsData);
  const { promiseInProgress } = usePromiseTracker({ area: 'placement-header-call', delay: 0 });
  const placementDetails = useSelector(selectPlacementHeaderData);
  const userPreference = useSelector(selectUserPreference);
  const candidateProfileDrawer = useSelector(selectCandidateProfileDrawer);
  const { vmsReqDetails } = useSelector(selectPlacementHeaderData);

  const { t } = useTranslation();
  const [width, setWidth] = React.useState(null);
  const { classes } = useStyles({ width: width });
  const [openProfileDrawer, setOpenProfileDrawer] = useState<IOpenProfileDrawer>({
    placementSidePanel: false,
  });
  const badgeRef = React.useRef(null);
  const latestOrderDrawerRequestIdRef = React.useRef(0);
  const latestOrderDrawerStateRef = React.useRef(orderDrawer);
  const [openPlacementChangeDialog, setOpenPlacementChangeDialog] = useState<boolean>(false);
  const openDialog = () => setOpenPlacementChangeDialog(true);
  const closeDialog = () => setOpenPlacementChangeDialog(false);
  const [featureFlagMarginTool] = useDecision(ff_margin_tool_placement_profile);
  const [changeOrderFlag] = useDecision(ff_placement_ui_change_order_on_placement);
  const [colorTagOptions, setColorTagOptions] = React.useState<TagOption[]>([]);
  const { placementFlagTypeId } = useSelector(selectPlacementTags);
  const placementColorTag = colorTagOptions?.find(tag => tag?.value === placementFlagTypeId);

  React.useEffect(() => {
    dispatch(
      globalActions.setDetailsPageDrawer({
        open: candidateProfileDrawer?.open || openProfileDrawer.placementSidePanel,
      }),
    );
    if (candidateProfileDrawer?.open || openProfileDrawer.placementSidePanel)
      dispatch(globalActions.resetAllRecentHistoryDrawers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openProfileDrawer, candidateProfileDrawer]);

  React.useEffect(() => {
    latestOrderDrawerStateRef.current = orderDrawer;
  }, [orderDrawer]);

  const { disciplineData } = useSelector(selectMiscellaneousPlacementData);
  const { candidate: candidateDetails } = useSelector(selectComparisonData);

  const {
    orderReq: {
      candidate: { covid, experience: candidateReqItem, certifications, licenses },
    },
    skillReq: { containers: skillContainers },
  } = useSelector(selectSubmissionInfo);

  const { candidateSellingPointCounts } = useSelector(selectPlacementCandidateRecords);

  React.useEffect(() => {
    const recentHistoryPrefs = userPreference?.recentHistory?.value;
    let newRecentHistoryPrefs = _.cloneDeep(recentHistoryPrefs);
    let placementArray: IRecentHistoryPlacement[] = recentHistoryPrefs?.placement
      ? [...recentHistoryPrefs?.placement]
      : [];

    const placementId = params?.placementId;
    const placementIdVal = parseInt(placementId);
    if (
      !isNotInteger(placementIdVal) &&
      ((placementArray?.length > 0 && placementArray[0].placementId !== placementIdVal) ||
        placementArray?.length === 0) &&
      placementIdVal > 0 &&
      recentHistoryPrefs !== null
    ) {
      const placementVal: IRecentHistoryPlacement = {
        placementId: placementIdVal,
      };
      let index = placementArray.findIndex(item => item.placementId === placementIdVal);

      if (index === -1) {
        placementArray.unshift(placementVal);
        if (placementArray.length > 5) {
          placementArray = placementArray.slice(0, 5);
        }
      } else {
        placementArray.splice(index, 1);
        placementArray.unshift(placementVal);
        if (placementArray?.length > 5) {
          placementArray = placementArray.slice(0, 5);
        }
      }
      newRecentHistoryPrefs = { ...newRecentHistoryPrefs, placement: placementArray };
      dispatch(
        userDevicePreferenceActions.saveUserRecentHistoryPreferenceAction({
          id: PreferenceCosmosKeys.recentHistory,
          value: newRecentHistoryPrefs,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPreference, params.placementId]);

  const candidatePhoneNumbers = React.useMemo(
    () => getDisplayableCandidatePhoneNumbers(placementDetails.candidate?.phoneNumber),
    [placementDetails.candidate?.phoneNumber],
  );
  const candidatePhoneNumber = candidatePhoneNumbers?.[0]?.phoneNumber;

  const handleNotificationData = (channel: ChannelType) => {
    const values = {
      facilityUnit: placementDetails?.placementUnit,
      accountManagerFirstName: placementContacts?.accountManager?.firstName,
      accountManagerLastName: placementContacts?.accountManager?.lastName,
      accountManagerEmailAddress: placementContacts?.accountManager?.email,
      accountManagerPhoneNumber: placementContacts?.accountManager?.phoneNumber,
      placementSellingPoints: candidateSellingPointCounts?.placementSellingPoints,
      candidateFirstName: placementDetails.candidate?.firstName,
      candidateLastName: placementDetails.candidate?.lastName,
      candidateGoesBy: placementDetails.candidate?.goesByName,
      candidateEmail: placementDetails?.candidatePrimaryEmail,
      candidateDiscipline: candidateDetails?.skillsets,
      currentAMNTraveler: candidateSellingPointCounts?.currentAmnTraveler,
      candidateDisciplineText: disciplineData,
      candidatePhoneNumber,
      availableStartDate: moment(placementDetails.availabilityDate).format('MM/DD/YYYY'),
      requestedTimeOff: candidateDetails?.requestedTimeOff,
      licenses: licenses?.data,
      certifications: certifications?.data?.candidateCredCertListResponse,
      totalYearsofExperience: `${
        candidateDetails?.totalYearsOfExp ? candidateDetails?.totalYearsOfExp?.toString() + 'Y' : ''
      } ${candidateDetails?.totalMonthsOfExp ? candidateDetails?.totalMonthsOfExp?.toString() + 'M' : ''}`,
      COVIDVaccineStatus: covid?.data?.vaccinationStatus,
      experience: candidateReqItem,
    };

    const substitutions = getSubstitutions(values);

    const sender = {
      name: Concatenate([user.userInfo?.firstName || '', user.userInfo?.lastName || ''], ' '),
      email: user.userInfo?.email,
      userId: `${user.userInfo?.employeeId}`,
      NtUserName: user.userInfo?.ntUserName,
      senderId: undefined,
    };
    const candidate = {
      name: Concatenate(
        [
          placementDetails.candidate?.firstName,
          placementDetails.candidate?.middleName || '',
          placementDetails.candidate?.lastName,
        ],
        ' ',
      ),
      email: placementDetails?.candidatePrimaryEmail,
      phoneNumber: candidatePhoneNumber,
      contactId: `${placementDetails.candidate?.id}`,
      brandId: `${placementDetails.brandId}`,
      ContactType: 'Candidate',
    };
    const voiceData = {
      brand: placementDetails?.brandName,
      channel: channel,
      associatedRecords: [
        { name: 'placementId', value: `${placementDetails?.placementId}` },
        { name: 'travelerId', value: `${placementDetails?.candidate?.id}` },
        { name: 'brandId', value: `${placementDetails?.brandId}` },
        { name: 'facilityId', value: `${placementDetails?.facility?.id}` },
        { name: 'recruiterId', value: `${placementDetails?.recruiterId}` },
        {
          name: 'recruiter',
          value: Concatenate([placementDetails?.recruiterFirstName, placementDetails?.recruiterLastName], ' '),
        },
      ],
      sender: sender,
      tos: [candidate],
      bccs: [sender],
      substitutions: substitutions,
      useType: UseType.Placement,
      userRole: Concatenate(user?.userInfo?.roles || [], ','),
      formName: FormName.Placement,
      purpose: CallPurpose.Prospecting,
      sendType: SendType.one_to_one,
      manualLog: false,
    };

    switch (channel) {
      case ChannelType.voice:
        if (!notificationData.voice.open && notificationData.voice.minimized) {
          dispatch(
            notificationDataActions.setVoiceInteraction({
              open: true,
              minimized: false,
              showDisposition: true,
              displayAddToSummary: true,
            }),
          );
          // Replace any stale voice data when reopening from minimized state so new call doesn't inherit old info
          dispatch(
            notificationDataActions.setVoiceData({
              data: voiceData,
              open: true,
              minimized: false,
              showDisposition: true,
              displayAddToSummary: true,
            }),
          );
          if (notificationData?.voice?.data?.tos.find(Boolean).contactId !== candidate?.contactId) {
            dispatch(notificationDataActions.setSnackBarData({ channel: 'voice', manual: false, changeWarning: true }));
          }
        } else {
          dispatch(
            notificationDataActions.setVoiceData({
              data: voiceData,
              open: true,
              minimized: false,
              displayAddToSummary: true,
            }),
          );
        }

        break;

      case ChannelType.email:
        voiceData['bccs'] = [sender];
        voiceData['body'] = '<br/><br/> {{signature}}';
        if (!notificationData.email.open && notificationData.email.minimized) {
          dispatch(
            notificationDataActions.setEmailInteraction({
              open: true,
              minimized: false,
            }),
          );
          dispatch(notificationDataActions.setSnackBarData({ channel: 'email', manual: false, changeWarning: true }));
        } else {
          dispatch(
            notificationDataActions.setNotificationData({
              ...notificationData,

              email: {
                data: {
                  ...EmailDefaultValues(),
                  ...voiceData,
                },
                open: true,
                minimized: false,
              },
              snackbarData: null,
            }),
          );
        }
        break;
    }
  };

  const avatarText = Concatenate(['PID', placementContacts?.placementId], ' ');
  const candidateName = Concatenate(
    [
      placementDetails.candidate?.firstName,
      placementDetails.candidate?.middleName || '',
      placementDetails.candidate?.lastName,
      `(${placementDetails.candidate?.id})`,
    ],
    ' ',
  );

  const candidateAddress = useMemo(() => {
    const candAddress = placementDetails.candidate?.address;
    return candAddress?.city && candAddress?.stateProvinceID && candAddress?.zip
      ? Concatenate([candAddress.city, candAddress.stateProvinceID, candAddress.zip], ', ')
      : missingField;
  }, [placementDetails.candidate?.address]);

  const lastContactInfo = GetMomentOfDate(placementDetails.candidateLastContactedOn);
  const [orderSkills, setOrderSkills] = useState<ISkillSetInfo[]>([]);

  React.useEffect(() => {
    const skills: ISkillSetInfo[] = [];
    skillContainers?.nodes?.forEach(g => {
      if (!g?.label) return;

      const parts = g.label.trim().split(' - ');
      if (parts.length < 2) return;

      const skill: ISkillSetInfo = {
        discipline: parts[0],
        specialty: parts.length === 3 ? `${parts[1]} - ${parts[2]}` : parts[1],
      };
      skills.push(skill);
    });
    setOrderSkills(skills);
  }, [skillContainers]);

  const placementSkills = skillContainers?.nodes?.find(node => node?.isPrimary);
  const facilityLink = React.useMemo(
    () => (
      <Link href={`/facility/${placementDetails.facility.id}`} data-testid="placement-facility-link">
        {`${placementDetails.facility.name} (${placementDetails.facility.id})`}
      </Link>
    ),
    [placementDetails.facility.id, placementDetails.facility.name],
  );
  const unitLink = React.useMemo(
    () => (
      <Link
        href={`/facility/${placementDetails.facility.id}/unit/${placementDetails.placementUnitId}`}
        data-testid="placement-unit-link"
      >
        {`${placementDetails.placementUnit} (${placementDetails.placementUnitId})`}
      </Link>
    ),
    [placementDetails.facility.id, placementDetails.placementUnitId, placementDetails.placementUnit],
  );

  React.useEffect(() => {
    const badgeWidth = badgeRef.current.offsetWidth;
    if (badgeWidth > 110) {
      setWidth(badgeWidth - 11);
    }
  }, [placementDetails]);

  React.useEffect(() => {
    getPlacementFlagTypes(setColorTagOptions);
  }, []);

  return (
    <>
      <LayoutGrid>
        <LayoutGridItem
          container
          xs={12}
          lg={12}
          sm={12}
          md={12}
          direction="row"
          spacing={2}
          classes={{ container: classes.container }}
        >
          <LayoutGridItem
            container
            xs={2}
            lg={2}
            sm={2}
            md={2}
            classes={{ root: `${classes.leftLings} ${classes.pidContainer}`, container: classes.container }}
          >
            {promiseInProgress && false ? (
              <Skeleton variant="rectangular" width={146} height={50} classes={{ rectangular: classes.skeleton }} />
            ) : (
              <>
                <div ref={badgeRef}>
                  <HeaderButton
                    headerAbbr=""
                    headerAbbrBackground="#003C69"
                    headerId={`PID ${placementDetails.placementId}`}
                    headerIdBackground="#05012E"
                    addOnControls={{ openPlacementChangeDialog: openDialog }}
                  />
                </div>
                <div>
                  {openPlacementChangeDialog && (
                    <PlacementChangeDialog openDialog={openPlacementChangeDialog} closeDialog={closeDialog} />
                  )}
                </div>
              </>
            )}
          </LayoutGridItem>
          <LayoutGridItem
            container
            alignItems="center"
            xs={10}
            lg={10}
            sm={10}
            md={10}
            classes={{ container: classes.container }}
          >
            {promiseInProgress && false ? (
              <Skeleton variant="rectangular" width={1400} height={50} classes={{ rectangular: classes.skeleton }} />
            ) : (
              <>
                <div className={classes.alignCenterDiv}>
                  <OverflowTooltip
                    value={facilityLink}
                    tooltipContent={`${placementDetails.facility.name} (${placementDetails.facility.id})`}
                    contentClass={classes.facilityTag}
                  />
                  <div className={`${classes.divSpace} ${classes.defaultText}`}>{`-`}</div>
                  <OverflowTooltip
                    value={unitLink}
                    tooltipContent={`${placementDetails.placementUnit} (${placementDetails.placementUnitId})`}
                    contentClass={classes.unitTag}
                  />
                  <div className={`${classes.divSpace} ${classes.defaultText}`}>{`-`}</div>
                  <Link
                    href={`/order/${placementDetails.orderId}`}
                    onClick={async event => {
                      // Allow new tab/window behavior for ctrl+click, meta+click, or middle mouse button
                      if (event.ctrlKey || event.metaKey) {
                        return; // Let the browser handle it normally (opens in new tab)
                      }
                      // For left click, prevent navigation and open side panel
                      event.preventDefault();
                      event.stopPropagation();
                      dispatch(globalActions.setFacilityDrawerData({ open: false, facility: undefined }));
                      dispatch(globalActions.setCandidateProfileDrawer({ open: false }));

                      const orderId = `${placementDetails.orderId}`;
                      const requestId = latestOrderDrawerRequestIdRef.current + 1;
                      latestOrderDrawerRequestIdRef.current = requestId;

                      dispatch(
                        globalActions.setOrderDrawerData({
                          open: true,
                          order: { orderId },
                        }),
                      );

                      try {
                        const response = await getAMIECategorySearch({
                          searchType: SearchType.order,
                          keyword: orderId,
                          pageNumber: 1,
                          pageSize: 25,
                          sortedColumn: { column: 'orderId', direction: 'desc' },
                        });

                        const matchedOrder = orderFlattenData(response?.items || []).find(
                          item => `${item?.orderId}` === orderId || `${item?.previewDrawerViewerId}` === orderId,
                        );

                        const isLatestRequest = latestOrderDrawerRequestIdRef.current === requestId;
                        const isDrawerStillOpenForOrder =
                          latestOrderDrawerStateRef.current?.open === true &&
                          latestOrderDrawerStateRef.current?.order?.orderId === orderId;

                        if (!isLatestRequest || !isDrawerStillOpenForOrder) {
                          return;
                        }

                        if (matchedOrder) {
                          dispatch(
                            globalSearchActions.setDrawerData({
                              open: true,
                              data: {
                                displayValue: orderId,
                                selectedorder: {
                                  row: {
                                    ...matchedOrder,
                                    previewDrawerViewerId: matchedOrder.previewDrawerViewerId ?? matchedOrder.orderId,
                                    indexCounter: matchedOrder.indexCounter ?? 0,
                                  },
                                },
                              },
                            }),
                          );

                          dispatch(
                            globalActions.setOrderDrawerData({
                              open: true,
                              order: { orderId, filesOut: matchedOrder.filesOut },
                            }),
                          );
                        }
                      } catch {
                        // Keep the drawer open with orderId even if the grid-style filesOut lookup fails.
                      }
                    }}
                    data-testid="placement-orderid-link"
                  >
                    {Concatenate([t('placement.profile.header.order'), '(' + placementDetails.orderId + ')'], ' ')}
                  </Link>
                  {changeOrderFlag.enabled && placementDetails.orderId && <ChangeOrderIDLink />}
                  <div className={`${classes.divSpace} ${classes.defaultText}`} style={{ minWidth: 'fit-content' }}>
                    <LayoutGrid container wrap="nowrap" alignItems="center">
                      <LayoutGridItem classes={{ root: classes.placementDateTitle }}>
                        {t('placement.profile.header.placementStartDate')}
                      </LayoutGridItem>
                      <LayoutGridItem item>
                        <PlacementStartDate
                          id={`${editAccessor}-${editableFields.placementStartDate}`}
                          maxWidth={215}
                        />
                      </LayoutGridItem>
                    </LayoutGrid>
                  </div>
                  <div className={`${classes.divSpace} ${classes.defaultText}`} style={{ minWidth: 'fit-content' }}>
                    <LayoutGrid container wrap="nowrap" alignItems="center">
                      <LayoutGridItem classes={{ root: classes.placementDateTitle }}>
                        {t('placement.profile.header.placementEndDate')}
                      </LayoutGridItem>
                      <LayoutGridItem item>
                        <PlacementEndDate id={`${editAccessor}-${editableFields.placementEndDate}`} maxWidth={215} />
                      </LayoutGridItem>
                    </LayoutGrid>
                  </div>
                  <div className={`${classes.divSpace} ${classes.defaultText}`} style={{ minWidth: 'fit-content' }}>
                    <LayoutGrid container wrap="nowrap" alignItems="center">
                      <LayoutGridItem classes={{ root: classes.placementDateTitle }}>
                        {t('placement.profile.header.placementLength')}
                      </LayoutGridItem>
                      <LayoutGridItem item>
                        <PlacementLength id={`${editAccessor}-${editableFields.numberOfWeeks}`} />
                      </LayoutGridItem>
                    </LayoutGrid>
                  </div>
                  <div className={`${classes.divSpace} ${classes.defaultText}`} style={{ minWidth: 'fit-content' }}>
                    <LayoutGrid container wrap="nowrap" alignItems="center">
                      <LayoutGridItem classes={{ root: classes.placementDateTitle }}>
                        {t('placement.profile.header.shift')}
                      </LayoutGridItem>
                      <LayoutGridItem item>
                        <PlacementShift id={`${editAccessor}-${editableFields.placementShift}`} />
                      </LayoutGridItem>
                    </LayoutGrid>
                  </div>
                </div>
              </>
            )}
          </LayoutGridItem>
        </LayoutGridItem>
        <LayoutGridItem
          container
          xs={12}
          lg={12}
          sm={12}
          md={12}
          direction="row"
          classes={{ container: classes.container }}
        >
          <LayoutGridItem direction="column" classes={{ root: `${classes.marginRight}` }}>
            <LayoutGridItem
              xs={2}
              lg={2}
              sm={2}
              md={2}
              direction="row"
              classes={{ root: `${classes.leftLings} ${classes.tableGridMargin}` }}
            >
              {promiseInProgress && false ? (
                <Skeleton variant="rectangular" width={146} height={60} classes={{ rectangular: classes.skeleton }} />
              ) : (
                <>
                  {placementDetails.isArchived ? (
                    <Button variant="outlined" color="primary" className={classes.archiveBtn} id={'btnArchive'}>
                      {t('placement.profile.header.archived')}
                    </Button>
                  ) : (
                    <Box width={146} height={10} data-testid={'notArchived'} />
                  )}
                  <Button
                    variant="outlined"
                    color="primary"
                    className={classes.contactBtn}
                    startIcon={<PersonIcon />}
                    onClick={() => {
                      setOpenProfileDrawer(prevState => ({
                        ...prevState,
                        placementSidePanel: true,
                      }));
                      dispatch(globalActions.setCandidateProfileDrawer({ open: false }));
                    }}
                    id={'btnPlacementContactSidePanelOpenTrigger'}
                  >
                    {t('placement.profile.header.keyContacts')}
                  </Button>
                  {openProfileDrawer.placementSidePanel && (
                    <HeaderContactDrawerOrder
                      openProfileDrawer={openProfileDrawer.placementSidePanel}
                      closeProfileDrawer={() =>
                        setOpenProfileDrawer(prevState => ({ ...prevState, placementSidePanel: false }))
                      }
                      avatarText={avatarText}
                      candidateName={placementContacts?.facility?.name}
                      placementDetails={placementContacts}
                      isTitleALink
                      titleLinkTo={`/facility/${placementDetails.facility.id}`}
                    />
                  )}
                </>
              )}
            </LayoutGridItem>
            {featureFlagMarginTool?.enabled && (
              <LayoutGridItem container xs={2} lg={2} sm={2} md={2}>
                <RouteLink to={`/margin/placement/${placementDetails?.placementId}/`}>
                  <CustomTooltip placement={'bottom-start'} tooltipContent={t('marginTool.marginTool')}>
                    <Grid className={`${classes.marginToolBtn}`}>
                      <img src={MarginToolIcon} alt="Margin Tool Icon" />
                    </Grid>
                  </CustomTooltip>
                </RouteLink>
              </LayoutGridItem>
            )}
          </LayoutGridItem>
          <LayoutGridItem
            container
            xs={10}
            lg={10}
            sm={10}
            md={10}
            direction="row"
            classes={{ root: classes.tableGridContainer }}
          >
            <LayoutGridItem
              container
              direction="row"
              classes={{ root: classes.tableGrid, container: classes.container }}
              sx={{
                maxWidth: { xs: '100%', sm: '100%', md: 300, lg: 300 },
                minWidth: { xs: 0, sm: 0, md: 220, lg: 220 },
                flexShrink: { xs: 1, sm: 1, md: 0, lg: 0 },
              }}
            >
              {promiseInProgress && false ? (
                <Skeleton variant="rectangular" width={260} height={60} classes={{ rectangular: classes.skeleton }} />
              ) : (
                <>
                  <LayoutGridItem sx={{ overflow: 'visible', maxWidth: '100%' }}>
                    <>
                      <Link
                        href={`/candidate/${placementDetails.candidate.id}/${placementDetails.brandId}`}
                        onClick={event => {
                          event.preventDefault();
                          event.stopPropagation();
                          setOpenProfileDrawer(prevState => ({
                            ...prevState,
                            placementSidePanel: false,
                          }));
                          dispatch(globalActions.setCandidateProfileDrawer({ open: true }));
                        }}
                        data-testid="placement-candidate-link"
                      >
                        {candidateName}
                      </Link>
                      {candidateProfileDrawer?.open && (
                        <DrawerFitted
                          onDrawerClose={() => {
                            dispatch(globalActions.setCandidateProfileDrawer({ open: false }));
                          }}
                          width={400}
                          top={0}
                          backgroundColor={theme.palette.framework.system.whisper}
                          open={candidateProfileDrawer?.open || false}
                        >
                          {
                            <CandidateDrawerPreviewer
                              isSearchGrid={false}
                              isWorkDesk={false}
                              travelerId={placementDetails.candidate.id}
                              hideNavigationArrows={true}
                              brandId={placementDetails.brandId}
                              closeDrawer={() => {
                                dispatch(globalActions.setCandidateProfileDrawer({ open: false }));
                              }}
                            />
                          }
                        </DrawerFitted>
                      )}
                    </>

                    <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.goesBy')}
                        rowContent={placementDetails.candidate.goesByName}
                        classes={classes}
                        customRowHeadClass={classes.fontSize12}
                        customRowContentClass={classes.rowContentMargin}
                        disableContentWrap
                        id={'lblPlacementHeaderGoesByName'}
                      />
                      <MediaQuery maxWidth={'md'}>
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.techVendor')}
                          rowContent={placementDetails.technologyVendorName}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderTechVendor'}
                        />
                      </MediaQuery>
                    </table>
                    <div className={classes.brandName} id={'lblPlacementHeaderBrandName'}>
                      {placementDetails.brandName}
                    </div>
                    <ResponsiveColumnContainer
                      rowHead={
                        <CustomTooltip
                          interactive={true}
                          tooltipContent={
                            placementDetails?.candidate.address.addressTypeId === 4
                              ? t('placement.profile.header.taxHomeAddress')
                              : t('placement.profile.header.permanentAddress')
                          }
                        >
                          <Typography style={{ fontSize: 12, fontWeight: 'normal', color: 'CaptionText' }}>
                            {t('placement.profile.header.cidAddress')}
                          </Typography>
                        </CustomTooltip>
                      }
                      rowContent={
                        <OverflowTooltip
                          value={candidateAddress}
                          tooltipContent={candidateAddress}
                          contentClass={classes.address}
                        />
                      }
                      classes={classes}
                      customRowContentClass={classes.rowContentMargin}
                      id={'lblPlacementHeaderCidAddress'}
                    />
                  </LayoutGridItem>
                  <MediaQuery minWidth={'md'}>
                    <Divider orientation="vertical" flexItem classes={{ root: classes.divider }} />
                  </MediaQuery>
                </>
              )}
            </LayoutGridItem>
            <LayoutGridItem
              container
              direction="row"
              classes={{ root: classes.tableGrid, container: classes.container }}
              sx={{
                maxWidth: { xs: '100%', sm: '100%', md: 350, lg: 350 },
                minWidth: { xs: 0, sm: 0, md: 220, lg: 220 },
                flexShrink: { xs: 1, sm: 1, md: 0, lg: 0 },
              }}
            >
              {promiseInProgress && false ? (
                <Skeleton variant="rectangular" width={260} height={60} classes={{ rectangular: classes.skeleton }} />
              ) : (
                <>
                  <Box sx={{ overflow: 'hidden', maxWidth: '100%' }}>
                    <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.ssn')}
                        rowContent={<SSN id="ssn-text-field-placement-header" />}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderSsn'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.dob')}
                        rowContent={<DateOfBirth />}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderDob'}
                      />

                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.email')}
                        rowContent={placementDetails.candidatePrimaryEmail}
                        classes={classes}
                        customRowContentClass={`${classes.link} ${classes.rowContentMargin}`}
                        handleNotificationData={handleNotificationData}
                        id={'lblPlacementHeaderEmail'}
                      />
                      <CustomTooltip
                        tooltipContent={
                          candidatePhoneNumbers?.length > 0 ? (
                            <CommunicationStack
                              channelType={ChannelType.voice}
                              phoneNumbers={candidatePhoneNumbers}
                              placementsCall
                            />
                          ) : (
                            <span>{`No number on file`}</span>
                          )
                        }
                      >
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.phoneNumber')}
                          rowContent={candidatePhoneNumber || '--'}
                          classes={classes}
                          customRowContentClass={`${classes.link} ${classes.rowContentMargin}`}
                          handleNotificationData={handleNotificationData}
                          id={'lblPlacementHeaderPhoneNumber'}
                        />
                      </CustomTooltip>

                      <MediaQuery maxWidth={'md'}>
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.bestTimeTocall')}
                          rowContent={<BestTimeToCall id={`${editAccessor}-${editableFields.bestTimeToCall}`} />}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderBestTimeTocall'}
                        />
                        <ResponsiveColumnContainer
                          rowHead={
                            <CustomTooltip
                              tooltipContent={
                                !!vmsReqDetails.vmsReqNo ? <TooltipVmsDetails vmsReqDetails={vmsReqDetails} /> : ''
                              }
                              globalStyles
                              isStandardContent
                            >
                              <span>{t('placement.profile.header.vmsReqNumber')}</span>
                            </CustomTooltip>
                          }
                          rowContent={<VmsReqNumber id={`${editAccessor}-${editableFields.vmsReqNo}`} />}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderVmsReqNumber'}
                        />
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.payCycleType')}
                          rowContent={placementDetails?.payCycleType || missingField}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderPayCycleType'}
                        />
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.payCycle')}
                          rowContent={
                            placementDetails.payCycle &&
                            placementDetails.payCycleStartDay &&
                            placementDetails.payCycleEndDay
                              ? `${placementDetails.payCycle} (${placementDetails.payCycleStartDay} - ${placementDetails.payCycleEndDay})`
                              : missingField
                          }
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderPayCycle'}
                        />
                        {isDisplayContractHours(placementDetails?.brandId) && (
                          <ResponsiveColumnContainer
                            rowHead={t('placement.profile.header.contractHours')}
                            rowContent={<ContractHours id={`${editAccessor}-${editableFields.contractHours}`} />}
                            classes={classes}
                            customRowContentClass={classes.rowContentMargin}
                            id={'lblPlacementHeaderContractHours'}
                          />
                        )}
                      </MediaQuery>
                    </table>
                  </Box>
                  <MediaQuery minWidth={'md'}>
                    <Divider orientation="vertical" flexItem classes={{ root: classes.divider }} />
                  </MediaQuery>
                </>
              )}
            </LayoutGridItem>
            <LayoutGridItem
              container
              direction="row"
              classes={{ root: classes.tableGrid, container: classes.container }}
              sx={{
                maxWidth: { xs: '100%', sm: '100%', md: 300, lg: 300 },
                minWidth: { xs: 0, sm: 0, md: 220, lg: 220 },
                flexShrink: { xs: 1, sm: 1, md: 0, lg: 0 },
              }}
            >
              {promiseInProgress && false ? (
                <Skeleton variant="rectangular" width={260} height={60} classes={{ rectangular: classes.skeleton }} />
              ) : (
                <>
                  <Box sx={{ overflow: 'visible', maxWidth: '100%' }}>
                    <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                      <MediaQuery maxWidth={'md'}>
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.lastContacted')}
                          rowContent={lastContactInfo.isValid() ? lastContactInfo.format('MM/DD/YYYY') : ''}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderLastContacted'}
                        />
                      </MediaQuery>
                    </table>
                    <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.maxFilesSend')}
                        rowContent={
                          placementDetails?.maxFilesSent
                            ? t('placement.profile.header.maxFilesSendStatus.yes')
                            : t('placement.profile.header.maxFilesSendStatus.no')
                        }
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderMaxFilesSend'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.screen')}
                        rowContent={placementDetails?.screen ?? missingField}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderScreen'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.availableStartDate')}
                        rowContent={
                          <AvailableStartDate
                            maxWidth={125}
                            id={`${editAccessor}-${editableFields.availabilityDate}`}
                          />
                        }
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderAvailableStartDate'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.lastContacted')}
                        rowContent={lastContactInfo.isValid() ? lastContactInfo.format('MM/DD/YYYY') : ''}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderLastContacted'}
                      />
                    </table>
                    <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                      <MediaQuery maxWidth={'md'}>
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.techVendor')}
                          rowContent={placementDetails.technologyVendorName}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderTechVendor'}
                        />
                      </MediaQuery>
                    </table>
                  </Box>
                  <MediaQuery minWidth={'lg'}>
                    <Divider orientation="vertical" flexItem classes={{ root: classes.divider }} />
                  </MediaQuery>
                </>
              )}
            </LayoutGridItem>
            <MediaQuery minWidth={'lg'}>
              <LayoutGridItem
                container
                direction="row"
                classes={{ root: classes.tableGrid, container: classes.container }}
                sx={{
                  maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: 400, xl: 400 },
                  minWidth: { xs: 0, sm: 0, md: 0, lg: 200, xl: 200 },
                  flexShrink: { xs: 1, sm: 1, md: 1, lg: 0, xl: 0 },
                }}
              >
                {promiseInProgress && false ? (
                  <Skeleton variant="rectangular" width={260} height={60} classes={{ rectangular: classes.skeleton }} />
                ) : (
                  <Box sx={{ overflow: 'visible', maxWidth: '100%' }}>
                    <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.bestTimeTocall')}
                        rowContent={<BestTimeToCall id={`${editAccessor}-${editableFields.bestTimeToCall}`} />}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderBestTimeTocall'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.techVendor')}
                        rowContent={placementDetails.technologyVendorName}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderTechVendor'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={
                          <CustomTooltip
                            tooltipContent={
                              !!vmsReqDetails.vmsReqNo ? <TooltipVmsDetails vmsReqDetails={vmsReqDetails} /> : ''
                            }
                            isStandardContent
                          >
                            <span>{t('placement.profile.header.vmsReqNumber')}</span>
                          </CustomTooltip>
                        }
                        rowContent={<VmsReqNumber id={`${editAccessor}-${editableFields.vmsReqNo}`} />}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderVmsReqNumber'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.payCycleType')}
                        rowContent={placementDetails?.payCycleType || missingField}
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        id={'lblPlacementHeaderPayCycleType'}
                      />
                      <ResponsiveColumnContainer
                        rowHead={t('placement.profile.header.payCycle')}
                        rowContent={
                          placementDetails.payCycle &&
                          placementDetails.payCycleStartDay &&
                          placementDetails.payCycleEndDay
                            ? `${placementDetails.payCycle} (${placementDetails.payCycleStartDay} - ${placementDetails.payCycleEndDay})`
                            : missingField
                        }
                        classes={classes}
                        customRowContentClass={classes.rowContentMargin}
                        disableContentWrap
                        id={'lblPlacementHeaderPayCycle'}
                      />
                      {isDisplayContractHours(placementDetails?.brandId) && (
                        <ResponsiveColumnContainer
                          rowHead={t('placement.profile.header.contractHours')}
                          rowContent={<ContractHours id={`${editAccessor}-${editableFields.contractHours}`} />}
                          classes={classes}
                          customRowContentClass={classes.rowContentMargin}
                          id={'lblPlacementHeaderContractHours'}
                        />
                      )}
                    </table>
                  </Box>
                )}
              </LayoutGridItem>
            </MediaQuery>
            <MediaQuery minWidth={'md'}>
              <Divider orientation="vertical" flexItem classes={{ root: classes.divider }} />
            </MediaQuery>
            <LayoutGridItem
              classes={{ root: classes.tableGridColumn5 }}
              sx={{
                maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: '100%', xl: '100%' },
                '@media (min-width: 1500px)': {
                  maxWidth: '450px',
                },
                '@media (min-width: 1024px) and (max-width: 1499px)': {
                  maxWidth: '320px',
                },
              }}
            >
              {promiseInProgress && false ? (
                <Skeleton variant="rectangular" width={200} height={60} classes={{ rectangular: classes.skeleton }} />
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', overflow: 'visible' }}>
                  <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.recruiter')}
                      rowContent={
                        placementDetails.recruiterFirstName && placementDetails.recruiterLastName
                          ? `${placementDetails.recruiterFirstName} ${placementDetails.recruiterLastName}`
                          : missingField
                      }
                      classes={classes}
                      customRowContentClass={classes.rowContentMargin}
                      disableContentWrap
                      minWidth={'md'}
                      id={'lblPlacementHeaderRecruiter'}
                    />
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.recruiter')}
                      rowContent={
                        placementDetails.recruiterFirstName && placementDetails.recruiterLastName
                          ? `${placementDetails.recruiterFirstName} ${placementDetails.recruiterLastName}`
                          : missingField
                      }
                      classes={classes}
                      minWidth={'xs'}
                      maxWidth={'sm'}
                      customRowHeadClass={`${classes.lowRatioLayout} ${classes.rowHeadDefaultColor}`}
                      customRowContentClass={`${classes.lowRatioLayout} ${classes.rowContentDefaultColor}`}
                      id={'lblPlacementHeaderRecruiter'}
                    />
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.accountManager')}
                      rowContent={
                        placementDetails.accountManagerFirstName && placementDetails.accountManagerLastName
                          ? `${placementDetails.accountManagerFirstName} ${placementDetails.accountManagerLastName}`
                          : missingField
                      }
                      classes={classes}
                      customRowContentClass={classes.rowContentMargin}
                      disableContentWrap
                      minWidth={'md'}
                      id={'lblPlacementHeaderAccountManager'}
                    />
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.accountManager')}
                      rowContent={
                        placementDetails.accountManagerFirstName && placementDetails.accountManagerLastName
                          ? `${placementDetails.accountManagerFirstName} ${placementDetails.accountManagerLastName}`
                          : missingField
                      }
                      classes={classes}
                      minWidth={'xs'}
                      maxWidth={'sm'}
                      customRowHeadClass={`${classes.lowRatioLayout} ${classes.rowHeadDefaultColor}`}
                      customRowContentClass={`${classes.lowRatioLayout} ${classes.rowContentDefaultColor}`}
                      id={'lblPlacementHeaderAccountManager'}
                    />
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.legalEntity')}
                      rowContent={
                        placementDetails.legalEntityType && placementDetails.legalEntityDescription
                          ? `${placementDetails.legalEntityType} - ${placementDetails.legalEntityDescription}`
                          : missingField
                      }
                      classes={classes}
                      customRowContentClass={classes.rowContentMargin}
                      disableContentWrap
                      minWidth={'md'}
                      id={'lblPlacementHeaderLegalEntity'}
                    />
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.legalEntity')}
                      rowContent={
                        placementDetails.legalEntityType && placementDetails.legalEntityDescription
                          ? `${placementDetails.legalEntityType} - ${placementDetails.legalEntityDescription}`
                          : missingField
                      }
                      classes={classes}
                      minWidth={'xs'}
                      maxWidth={'sm'}
                      customRowHeadClass={`${classes.lowRatioLayout} ${classes.rowHeadDefaultColor}`}
                      customRowContentClass={`${classes.lowRatioLayout} ${classes.rowContentDefaultColor}`}
                      id={'lblPlacementHeaderLegalEntity'}
                    />
                  </table>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'flex-start',
                      width: '100%',
                      marginTop: theme.spacing(1),
                      maxWidth: '100%',
                    }}
                  >
                    {placementColorTag && (
                      <Box
                        sx={{
                          backgroundColor: placementColorTag?.name,
                          alignSelf: 'flex-start',
                          marginRight: theme.spacing(0.5),
                        }}
                        className={classes.colorDot}
                      />
                    )}
                    <PlacementTagsWrapper />
                  </Box>
                </Box>
              )}
            </LayoutGridItem>
          </LayoutGridItem>
        </LayoutGridItem>
        <LayoutGridItem xs={12} lg={12} sm={12} md={12}>
          {promiseInProgress && false ? (
            <Skeleton variant="rectangular" width={1270} height={40} classes={{ rectangular: classes.skeleton }} />
          ) : (
            <LayoutGridItem
              container
              justifyContent="space-between"
              xs={12}
              lg={12}
              xl={12}
              classes={{ root: classes.tailStrip }}
            >
              <LayoutGridItem classes={{ root: classes.headerData }}>
                <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                  <ResponsiveColumnContainer
                    rowHead={t('placement.profile.header.facilityLoc')}
                    rowContent={<FacilityLocation />}
                    classes={classes}
                    customRowHeadClass={classes.tailStripHead}
                    disableContentWrap
                    id={'lblPlacementHeaderFacilityLoc'}
                  />
                </table>
              </LayoutGridItem>
              <LayoutGridItem container sx={theme => ({ width: 'auto', gap: theme.spacing(2) })}>
                <LayoutGridItem classes={{ root: classes.headerData }}>
                  <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.placementSkill')}
                      rowContent={placementSkills?.label}
                      classes={classes}
                      customRowHeadClass={classes.tailStripHead}
                      disableContentWrap
                      id={'lblPlacementHeaderSkill'}
                    />
                  </table>
                </LayoutGridItem>
                <LayoutGridItem classes={{ root: classes.headerData }}>
                  <table style={{ display: 'table-caption', wordBreak: 'keep-all' }}>
                    <ResponsiveColumnContainer
                      rowHead={t('placement.profile.header.orderSkill')}
                      rowContent={<SkillSetContent skillSets={orderSkills} isOrderHeader={true} />}
                      classes={classes}
                      customRowHeadClass={classes.tailStripHead}
                      disableContentWrap
                      id={'lblPlacementHeaderOrderSkill'}
                    />
                  </table>
                </LayoutGridItem>
              </LayoutGridItem>
            </LayoutGridItem>
          )}
        </LayoutGridItem>
      </LayoutGrid>
      {orderDrawer?.open && (
        <DrawerFitted
          onDrawerClose={() => {
            dispatch(globalActions.setOrderDrawerData({ open: false, order: undefined }));
          }}
          width={450}
          top={0}
          backgroundColor={theme.palette.framework.system.whisper}
          open={orderDrawer?.open || false}
        >
          {orderDrawer?.order?.orderId && (
            <OrderPreviewDrawerViewer orderId={orderDrawer.order.orderId} filesOut={orderDrawer.order.filesOut} />
          )}
        </DrawerFitted>
      )}
    </>
  );
};
